import Banner from "./components/Banner";
import NFt2 from "assets/img/nfts/Nft2.png";
import NFt3 from "assets/img/nfts/Nft3.png";
import NFt5 from "assets/img/nfts/Nft5.png";
import NftCard from "components/card/NftCard";

const Marketplace = () => {
  return (
    <div className="mt-3 w-full">
      {/* Banner */}
      <Banner />

      {/* Header */}
      <div className="mb-4 mt-5 flex flex-col justify-between px-4 md:flex-row md:items-center">
        {/* Agrega aquí el contenido del header si es necesario */}
      </div>

      {/* Trending cards */}
      <div className="z-20 grid grid-cols-1 gap-5 md:grid-cols-3">
        <div>
          <NftCard
            bidders={[]}
            title="Crear Empleado"
            author="Es una herramienta integral diseñada para optimizar y facilitar el proceso de contratación en tu empresa. Esta plataforma está creada para identificar, evaluar y seleccionar a los mejores candidatos de manera eficiente."
            price="0"
            image={NFt3}
          />
          
        </div>

        <div>
          <NftCard
            bidders={[]}
            title="Lista de Empleados"
            author="Gestión de empleados está diseñado para simplificar y optimizar todas las tareas relacionadas con la administración del personal en tu empresa."
            price="0"
            image={NFt2}
          />
       
        </div>

        <div>
          <NftCard
            bidders={[]}
            title="Diligencia de Descargos Laborales"
            author="Es una herramienta especializada diseñada para manejar de manera eficiente y profesional los procesos de descargos y diligencias disciplinarias en tu empresa."
            price="0"
            image={NFt5}
          />
          
        </div>
      </div>
    </div>
  );
};

export default Marketplace;
